import { Container, Row } from "reactstrap";
import BasicMap from "./BasicMap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { GoogleMapTitle, MapTitle } from "../../../../Constants/Constants";
import MarkerMaps from './MarkerMaps'
import PolygonsMap from './PolygonsMap'
import PolylineMaps from './PolylineMaps'
import { Fragment } from "react/jsx-runtime";

const GoogleMapsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={GoogleMapTitle} parent={MapTitle} />
      <Container fluid>
        <Row>
          <BasicMap />
          <MarkerMaps/>
          <PolygonsMap/>
          <PolylineMaps/>
        </Row>
      </Container>
    </Fragment>
  );
};
export default GoogleMapsContainer;
